import {useCallback, useEffect, useRef, useState} from 'react';

const BURST_MS = 3000;
const TAPS_REQUIRED = 7;

let revealed = false;
const listeners = new Set<(value: boolean) => void>();

function set(value: boolean) {
  if (revealed === value) return;
  revealed = value;
  listeners.forEach(fn => fn(value));
}

export function useDebugMenuRevealed(): boolean {
  const [value, setValue] = useState<boolean>(revealed);
  useEffect(() => {
    listeners.add(setValue);
    return () => { listeners.delete(setValue); };
  }, []);
  return value;
}

export function useDebugMenuTap(): () => void {
  const countRef = useRef(0);
  const firstTapRef = useRef(0);
  return useCallback(() => {
    if (revealed) return;
    const now = Date.now();
    if (now - firstTapRef.current > BURST_MS) {
      countRef.current = 1;
      firstTapRef.current = now;
    } else {
      countRef.current += 1;
    }
    if (countRef.current >= TAPS_REQUIRED) {
      set(true);
    }
  }, []);
}
